import styled from "styled-components";

export const StyledGrayCard = styled.div`
    background-color: var(--color-grey-500);
    padding: 15px;
    border-radius: 8px;
    margin: 10px 0;
`;

export default StyledGrayCard;
